export const environment = {
  production: false,
  urlApi: 'https://plk1lh8c88.execute-api.us-east-1.amazonaws.com/dev/api/v1',
  // urlApi: 'https://r4af17h38h.execute-api.us-east-1.amazonaws.com/prod/api/v1',
  // urlApi: 'http://192.168.168.128:8005/api/v1',
  // API pública de códigos postales (Copomex / SEPOMEX). No lleva token.
  // Debe existir también en environment.production.ts: no hay tipado que
  // fuerce la paridad entre ambos archivos, así que si falta en uno la build
  // de esa configuración rompe.
  urlCopomexApi: 'https://svfe6rn4f1.execute-api.us-east-1.amazonaws.com/dev/api/v1',
  firebase: {
    projectId:"cradleresident",
    appId:"1:392168572149:web:dc2a1905640cc2564431bc",
    storageBucket:"cradleresident.firebasestorage.app",
    apiKey:"AIzaSyCA4w3n0x5ZxkHMZ80D3njzbuUc6NlZ1-M",
    authDomain:"cradleresident.firebaseapp.com",
    messagingSenderId:"392168572149",
    measurementId:"G-9G3X8ZXJ57"
  }
  // ESTA URL CREO QUE ES DE ECR
  // urlApi: 'https://dw3mcppo5l.execute-api.us-east-1.amazonaws.com/dev/api/v1',
};
